import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components

import { Box } from "@mui/material";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/cardFooterStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function CardFooter(props) {
  const { className, children, plain, profile, stats, chart, ...rest } = props;

  const targetData = {
    "cardFooter": true,
    "cardFooterPlain": plain,
    "cardFooterProfile": profile,
    "cardFooterStats": stats,
    "cardFooterChart": chart
  };

  const keyArray = getKeyArray(targetData);

  return (
    <Box sx={getBaseSxStyle(styles, keyArray)} {...rest}>
      {children}
    </Box>
  );
}

CardFooter.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  stats: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node
};
